'use client';

import { useEffect } from 'react';

import { pinEmbedPalette } from '../lib/embedPalette';
import { embedPaletteFromParams, isEmbedRoute } from '../lib/embedParams';

/** Set by the gallery while it previews a dark widget; unreadable where storage is blocked. */
function isGalleryPreviewDark(): boolean {
    try {
        return localStorage.getItem('widget-preview-theme') === 'dark';
    } catch {
        return false;
    }
}

/**
 * Pins the palette an embed route asked for in its URL (any of the spellings in
 * `embedPaletteFromParams`, light by default), so a widget never picks up the
 * visitor's own kalshi.com theme. Widgets that render their own dark variant pin
 * it too; the two agree because both read the same params. Every other route (the
 * gallery) is light.
 *
 * Skips the installation page, which pins its own palette, and the gallery's dark
 * preview, where the previewed widget pins dark while the gallery itself stays light.
 */
export function EmbedPalette() {
    useEffect(() => {
        const { pathname, search } = window.location;
        if (pathname.startsWith('/installation')) return;
        const palette = isEmbedRoute(pathname) ? embedPaletteFromParams(new URLSearchParams(search)) : 'light';
        if (palette === 'light' && isGalleryPreviewDark()) return;
        pinEmbedPalette(palette);
    }, []);

    return null;
}
